const LOG_LEVELS = { none: 0, error: 1, warn: 2, info: 3, debug: 4 };

// Default to 'info', but 'none' in test environments.
const config = { default: process.env.NODE_ENV === 'test' ? 'none' : 'info' };

let logConfigStr = '';
// In a browser environment, check localStorage.
if (typeof window !== 'undefined') {
  logConfigStr = window.localStorage.getItem('LOG_LEVELS');
}

// Fall back to process.env for Node.js scripts or if localStorage is not set.
if (!logConfigStr && typeof process !== 'undefined' && process.env) {
  logConfigStr = process.env.LOG_LEVELS;
}

// Parse a string like "ActionSystem:debug,AISolver:info"
(logConfigStr || '').split(',').forEach(part => {
  if (!part) return;
  const [name, level] = part.split(':');
  if (name && LOG_LEVELS[level] !== undefined) {
    config[name.trim()] = level.trim();
  }
});

class Logger {
  constructor(name) {
    this.name = name;
    const levelName = config[name] || config.default;
    this.level = LOG_LEVELS[levelName];
  }

  _log(level, levelName, ...args) {
    if (this.level >= level) {
      // e.g., "[INFO] ActionSystem: Your message here"
      console.log(`[${levelName.toUpperCase()}] ${this.name}:`, ...args);
    }
  }

  debug(...args) { this._log(LOG_LEVELS.debug, 'debug', ...args); }
  info(...args) { this._log(LOG_LEVELS.info, 'info', ...args); }
  log(...args) { this._log(LOG_LEVELS.info, 'info', ...args); } // alias
  warn(...args) { this._log(LOG_LEVELS.warn, 'warn', ...args); }
  error(...args) { this._log(LOG_LEVELS.error, 'error', ...args); }
}

const loggers = {};
const getLogger = (name) => {
  if (!loggers[name]) {
    loggers[name] = new Logger(name);
  }
  return loggers[name];
};

export default getLogger;
